import { object, string, ref } from 'yup';

export default object().shape({
  currentPassword: string()
    .required('Please enter your password')
    .min(6, 'Choose a password 6 digits or longer'),
  password: string()
    .required('Please enter your new password')
    .min(6, 'Choose a password 6 digits or longer'),
  passwordConfirmation: string()
    .oneOf([ref('password'), null], 'The specified passwords do not match')
    .required('Please confirm your new password')
});
